import { NgModule } from "@angular/core";
import { RouterModule, Routes, PreloadAllModules } from "@angular/router";
import { AuthGuard } from "./shared/guards/auth.guard";
import { environment } from "src/environments/environment";

import { CommonLayoutComponent } from "./layouts/common-layout/common-layout.component";
import { CommonLayout_ROUTES } from "./shared/routes/common_layout.routes";

const runtimeEnv =
  typeof window !== "undefined" && (window as any).__env ? (window as any).__env : {};

const parseBooleanFlag = (value: any, fallback: boolean): boolean => {
  if (value === undefined || value === null) {
    return fallback;
  }

  if (typeof value === "boolean") {
    return value;
  }

  const normalized = String(value).trim().toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) {
    return true;
  }
  if (["false", "0", "no", "off"].includes(normalized)) {
    return false;
  }

  return fallback;
};

const resolveAppEnv = (): string => {
  const sourceValue =
    runtimeEnv.APP_ENV ??
    runtimeEnv.appEnv ??
    (environment as any).APP_ENV ??
    environment.appEnv ??
    "";

  if (typeof sourceValue === "string") {
    return sourceValue.trim().toLowerCase();
  }

  if (sourceValue === null || sourceValue === undefined) {
    return "";
  }

  return String(sourceValue).trim().toLowerCase();
};

const appEnv = resolveAppEnv();
const bypassLoginFlag = parseBooleanFlag(
  runtimeEnv.BYPASS_LOGIN ??
    runtimeEnv.bypassLogin ??
    (environment as any).BYPASS_LOGIN ??
    environment.bypassLogin,
  false
);

const bypassLoginEnabled = appEnv === "local" && bypassLoginFlag;

const defaultRedirect = bypassLoginEnabled ? "/dashboard/home" : "/authentication/login";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: defaultRedirect,
    pathMatch: "full",
  },
  {
    path: "authentication",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "",
    component: CommonLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: CommonLayout_ROUTES,
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
